import { render, staticRenderFns } from "./PreContratoForm.vue?vue&type=template&id=6b7e84bc"
import script from "./PreContratoForm.vue?vue&type=script&lang=js"
export * from "./PreContratoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports